import { convertToYYYYMMDD } from '@src/util/date-format'

export enum CheckupStepType {
  ACCOUNT = 'account',
  HEALTH = 'health',
  BODY_MEASUREMENTS = 'body_measurements',
  GOALS = 'goals',
  // TASKS = 'tasks',
  TRAINING = 'training',
  NOTES = 'notes',
  FINISH = 'finish'
}

export enum CheckupState {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  PLANNED = 'planned'
}

export default class Checkup {

  id: number
  healthLimitationsSetId: number | null
  healthLimitationsSetAdded: boolean
  healthGoalId: number | null
  healthGoalAdded: boolean
  bodyMeasurementIds: number[]
  bodyMeasurementsAdded: boolean
  taskIds: number[]
  tasksAdded: boolean
  noteIds: number[]
  notesAdded: boolean
  trainingPlanId: number | null
  trainingPlanAdded: boolean
  workoutId: number | null
  workoutAdded: boolean
  plannedDate: string
  completedDate: string
  state: CheckupState

  /**
   * Onboarding checkup has 1 extra step:
   * - account: true, since this will be the first steps visible to the user
   */
  registrationAdded: boolean | null = null
  generalInfoAdded: boolean | null = null

  constructor (attributes?) {
    Object.assign(this, attributes)
    // TODO remove when integrating tasks step back
    this.tasksAdded = true
  }

  isComplete (): boolean {
    // either the state is completed or all steps are completed
    return this.state === CheckupState.COMPLETED
      || (this.healthLimitationsSetAdded && this.healthGoalAdded && this.bodyMeasurementsAdded && this.tasksAdded && this.notesAdded && this.trainingPlanAdded && this.workoutAdded)
  }

  updateState (): void {
    if (this.isComplete()) {
      this.state = CheckupState.COMPLETED
      this.completedDate = convertToYYYYMMDD(new Date())
    } else {
      this.state = CheckupState.IN_PROGRESS
    }
  }

  forceComplete (): void {
    this.state = CheckupState.COMPLETED
    this.completedDate = convertToYYYYMMDD(new Date())
  }

  getSteps (flags?: { omitNotes: boolean, omitFinish: boolean }): CheckupStep[] {
    let steps: CheckupStep[] = []
    if (this.registrationAdded || this.generalInfoAdded) {
      steps.push({ type: CheckupStepType.ACCOUNT, completed: true })
    }
    steps.push({ type: CheckupStepType.GOALS, completed: this.healthGoalAdded })
    steps.push({ type: CheckupStepType.BODY_MEASUREMENTS, completed: this.bodyMeasurementsAdded })
    steps.push({ type: CheckupStepType.HEALTH, completed: this.healthLimitationsSetAdded })
    steps.push({ type: CheckupStepType.TRAINING, completed: this.trainingPlanAdded || this.workoutAdded })
    if (!flags || (flags && !flags.omitNotes)) {
      steps.push({ type: CheckupStepType.NOTES, completed: this.notesAdded })
    }
    if (!flags || (flags && !flags.omitFinish)) {
      steps.push({ type: CheckupStepType.FINISH, completed: this.isComplete() })
    }

    return steps
  }

  startOnboarding () {
    this.registrationAdded = true
    if (!this.generalInfoAdded) {
      this.generalInfoAdded = false
    }
  }
}

export type CheckupStep = {
  type: CheckupStepType
  completed: boolean | undefined
}
